import React from 'react';

function Grok() {
  return (
    <div className='text-white'>Grok</div>
  )
}

export default Grok;